module.exports = __webpack_public_path__ + "11f850b0786a9d0fdde3b45464492a6b.svg";